module.exports = __webpack_public_path__ + "assets/blog/images/frank-luca-wUo-wgIHTac-unsplash_cropped.webp";